import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"
// since lkq styling, this seems to be obsolete
export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    defaultProps: {
        noOffsetOnActive: true,
    },
    styleOverrides: {
        root: {
            margin: "0",
            borderRadius: "0",
            "&:hover:not(.active)": {
                background: "#C8C8C8",
            },
            "&.active": {
                backgroundColor: "transparent",
                color: "#000",
                "& svg": {
                    fill: "#e6001e",
                    background: "transparent",
                },
            },
            "&.central-ordering": {
                borderRight: "1px solid #c8c8c8",
            },
            "&.user-settings": {
                borderRight: "1px solid #c8c8c8",
            },
        },
        icon: {
            opacity: "1",
            "&:hover": {
                opacity: "1",
            },
            ".active > &": {
                opacity: "1",
            },
        },
        image: {
            opacity: "1",
            "&:hover": {
                opacity: "1",
            },
            ".active > &": {
                opacity: "1",
            },
        },
    },
})
